<template>
	<div>
		<!-- <top></top> -->
		<div class="conmtont">
			<div class="flex align-center justify-between padding-sm bg-white margin-tb">
				<!-- <p class="text-sm text-666">首页 - 找工作 - 详情</p>
				<p class="flex align-center text-999 text-sm pointer" @click="back()">
					<i class="el-icon-back"></i>
					<span>返回</span>
				</p> -->
				<el-breadcrumb separator-class="el-icon-minus">
					<el-breadcrumb-item :to="{ path: '/' }"><span class="text-sm text-666">首页</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: 'worker' }"><span class="text-sm text-666">找工作</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item><span class="text-sm">详情</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="flex">
				<div class="flex-sub">
					<div class="bg-white padding-sm radius">
						<div class="text-32 text-000 text-bold text-left">{{title}}</div>
						<div class="flex justify-between align-center">
							<div class="margin-top-sm">
								<div class="flex align-center justify-between">
									<p class="flex align-center">
										<img v-if="userinfo" :src="userinfo&&userinfo.avatar" class="block-30">
										<span class="text-sm text-333 margin-left-xs"
											v-if="company||userinfo">{{company&&company.name||userinfo.nick_name}}</span>
									</p>
									<div class="flex align-center margin-left-xs" v-if="userinfo">
										<img v-if="userinfo.is_real == 2" class="block-15 margin-right-xs"
											src="https://manage.ciiply.com/web/static/home/authentication.png"
											mode=""></img>

										<img v-if="userinfo.is_real_company == 2" class="block-15 margin-right-xs"
											src="https://manage.ciiply.com/web/static/home/enterprise.png" mode=""></img>
										<img v-else class="block-15 margin-right-xs"
											src="https://manage.ciiply.com/web/static/home/random.png" mode=""></img>
										<p class="text-sm text-theme margin-left-xs">
											{{userinfo.is_real_company == 2?'企业已认证':userinfo.is_real == 2?'个人已认证':'未认证'}}
										</p>
									</div>
								</div>
								<div class="flex align-center justify-between margin-top-xs">
									<p class="margin-right">
										<i class="el-icon-location-outline"></i>
										<span class="text-sm text-666">{{area}}</span>
									</p>
									<p>
										<span class="text-sm text-999">待遇</span>
										<span class="text-prices">{{salary}}/{{settlement == '日结'?'日':'月'}}</span>
									</p>
								</div>
							</div>
							<div class="flex align-center">
								<div class="colt flex align-center justify-center pointer" @click="chosecoll">
									<i class="el-icon-star-off text-theme"></i>
									<p class="margin-left-xs text-666">{{coll?'已收藏':'收藏'}}</p>
								</div>
								<div class="callbtns flex align-center justify-center margin-left-xs pointer"
									@click="callphone">
									<img class="call-icon" src="../../assets/img/call-icon.png">
									<p class="text-white margin-left-xs">电话联系</p>
								</div>
							</div>
						</div>
					</div>
					<div class="bg-white margin-top padding-sm radius">
						<p class="title text-left padding-left-sm">职位详情</p>
						<div class="flex align-center margin-top-xs">
							<p class="tip text-sm text-666 margin-right-xs" v-for="(item,index) in category"
								:key="index">{{item.work_categroy_name}}工种</p>
							<p class="tip text-sm text-666 margin-right-xs">{{settlement}}</p>
							<p class="tip text-sm text-666 margin-right-xs">{{experience}}年经验</p>
						</div>
					</div>
					<div class="bg-white margin-top padding-sm radius" v-if="company">
						<p class="title text-left padding-left-sm">企业介绍</p>
						<p class="text-left margin-top-sm" v-html="company.content"></p>
					</div>
					<!-- <div class="bg-white margin-top padding-sm radius">
						<p class="title text-left padding-left-sm">工作位置</p>
						 <div class="txMap margin-top-sm">
						    <div id="allmap"></div>
						  </div>
					</div> -->
				</div>
				<!-- <div class="margin-left">
					<div class="flex align-center justify-between margin-bottom-sm">
						<p class="title padding-left-sm ">最新招工</p>
					</div>
					<div v-for="(item,indx) in 3" :key="indx">
						<StationList :width="387" :height="168" :size="18"></StationList>
					</div>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	import Top from '@/components/public/top.vue';
	import StationList from '@/components/list/station-list.vue';
	export default {
		components: {
			Top,
			StationList
		},
		name: '',
		data() {
			return {
				latitude: 39.92855, //经纬度
				longitude: 116.41637, //经纬度
				id: 0, //
				token: '',
				title: '', //标题
				area: '', //地址
				settlement: '', //结算方式
				experience: '', //经验
				content: '', //职位详情
				salary: '', //薪资
				userinfo: null, //用户信息
				company: null, //企业信息
				coll: 0, //1收藏0未收藏
				phone_num: '',
				category: [], //工种
				isbuy: false, //是否花积分购买
			}
		},
		created() {
			//通知听不状态栏 选中的页面
			Bus.$emit('chosename', 'worker')
			console.log(this.$route.query.id)
			this.id = this.$route.query.id
			this.getdetail()
			this.getisbuyjifen()
		},
		mounted() {
			// this.initMap2()
		},
		methods: {
			back() {
				this.$router.back()
			},
			//判断是否花费积分购买
			getisbuyjifen() {
				this.ajax('get', '/api/integral/is_buy', {
					work_id: this.id,
					work_type: 1
				}, res => {
					if (res.status == 200) {
						if (res.data.code == 202) {
							this.isbuy = false
						}
						if (res.data.code == 200) {
							this.isbuy = true
						}
					}
				})
			},
			//电话联系
			callphone() {
				if (this.isbuy) {
					let phone_num = this.phone_num
					this.$alert('联系电话为：' + phone_num, '提示', {
						confirmButtonText: '确定',
						callback: action => {

						}
					});
				} else {
					this.$confirm('需要积分兑换即可查看完整电话', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
					 type: 'warning'
					}).then(() => {
						this.getbuy()
					}).catch(() => {

					});
				}
			},
			//花费积分购买
			getbuy() {
				let that = this
				that.ajax('post', '/api/integral/buy', {
					work_id: that.id,
					work_type: 1
				}, res => {
					if (res.status == 200) {
						if (res.data.code == 200) {
							that.$message("兑换成功")
							// this.$message.info('兑换成功');
							that.getisbuyjifen()
							let phone_num = that.phone_num
							that.$alert('联系电话为：' + phone_num, '提示', {
								confirmButtonText: '确定',
								callback: action => {
							
								}
							});
						}
					}
				})
			},
			//收藏取消收藏
			chosecoll() {
				this.ajax('post', '/api/collection/add', {
					type_id: this.id,
					type: 0
				}, res => {
					if (res.status == 200) {
						this.coll = !this.coll
						this.getdetail()
					} else {
						this.careful = ''
					}
				})

			},
			/**
			 * 获取详情
			 * */
			getdetail() {
				this.ajax('get', '/api/pc/work/getWorkInfo', {
					id: this.id,
				}, res => {
					if (res.status == 200) {
						this.title = res.data.title
						this.area = res.data.area
						this.latitude = res.data.lat
						this.longitude = res.data.lng
						this.settlement = res.data.settlement
						this.experience = res.data.experience
						this.content = res.data.content
						this.salary = res.data.salary
						this.userinfo = res.data.user
						this.coll = res.data.coll
						this.phone_num = res.data.user && res.data.user.phone
						this.company = res.data.company
						if (res.data.user && res.data.user.is_real_company == 2) {

						}
						this.category = res.data.category
					}
				})
			},
			//初始化渲染地图
			initMap2() {
				//    console.log("window", window);
				//    // 定义地图中心点坐标
				//    let center = new TMap.LatLng(39.906632, 116.413306);// 坐标靠近中间
				//    // 定义map变量，调用 TMap.Map() 构造函数创建地图
				//    var map = new TMap.Map(document.getElementById("allmap"), {
				//      center: center,
				//      zoom: 15
				//    });
				//    //   //初始marker
				//    var marker = new TMap.MultiMarker({
				//      id: 'marker-layer',
				//      map: map,
				//      styles: {
				//        // mark样式
				//        "marker": new TMap.MarkerStyle({
				//          "width": 25,
				//          "height": 38,
				//          "anchor": { x: 12, y: 32 },
				//        })
				//      },
				//      geometries: [{
				//        "id": 'demo1',
				//        "styleId": 'marker',
				//        "position": new TMap.LatLng(39.906632, 116.413306),
				//        "properties": {
				//          "title": "北京市东城区台基厂头条3号(王府井地铁站C3西南口步行470米)",
				//          "address": "",
				//        }
				//      }]
				//    });
				//    //初始化infoWindow
				//    var infoWindow = new TMap.InfoWindow({
				//      map: map,
				//      position: new TMap.LatLng(39.906632, 116.413306),
				//      offset: { x: 0, y: -32 }, //设置信息窗相对position偏移像素，为了使其显示在Marker的上方
				//    });
				//    // infoWindow.close();//初始关闭信息窗关闭
				// console.log(marker);
				// let add = marker.geometries[0]
				// infoWindow.open(); //打开信息窗
				// infoWindow.setPosition(add.position);//设置信息窗位置
				// infoWindow.setContent(`<div style="white-space:
				//   nowrap;margin:10px;color:#000;text-align:left;"> 
				//   <p style="font-size:16px;">${add.properties.title}</p>
				//    </div>`);//设置信息窗内容
				//    //监听标注点击事件
				//    marker.on("click", function (evt) {
				//      console.log(evt)
				//      //设置infoWindow
				//      infoWindow.open(); //打开信息窗
				//      infoWindow.setPosition(evt.geometry.position);//设置信息窗位置
				//      infoWindow.setContent(`<div style="white-space:
				//        nowrap;margin:10px;color:#000;text-align:left;"> 
				//        <p style="font-size:16px;">${evt.geometry.properties.title}</p>
				//         </div>`);//设置信息窗内容
				//    })
			},
		}
	}
</script>

<style scoped lang="less">
	.text-32 {
		font-size: 32px;
	}

	.title {
		position: relative;
		font-size: 22px;

		&:before {
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 6px;
			height: 26px;
			background: #09827B;
			content: '';

		}
	}

	.block-30 {
		width: 30px;
		height: 30px;
		border-radius: 50%;
	}

	.colt {
		width: 111px;
		height: 45px;
		background: #FFFFFF;
		border: 1px solid #E6E6E6;
		border-radius: 23px;
	}

	.tip {
		padding: 12px 28px;
		background: #FFFFFF;
		box-shadow: 0px 5px 29px 2px rgba(204, 204, 204, 0.3000);
		border-radius: 20px;
	}

	.callbtns {
		width: 193px;
		height: 45px;
		background: #0B837C;
		border-radius: 23px;

		.call-icon {
			width: 19px;
			height: 19px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/index/worker-detail.vue